// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-block{
  margin-top: 20px;
}

.pagination-button{
  cursor: pointer;
  margin-right: 4px;
  width: 40px;
  height: 40px;
  background-color: #FFFFFF;
  color: #434C63;
  border: 1px solid #434C63;
  border-radius: 5px;
  transition: background-color linear .2s, color linear .2s;
}

.pagination-button:last-child{
  margin-right: 0;
}

.pagination-button:hover{
  background-color: #434C63;
  color: #FFFFFF;
}

.pagination-button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.ellipsis{
  display: inline-block;
  width: 30px;
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./src/components/Pagination/style.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yDAAyD;AAC3D;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,kBAAkB;AACpB","sourcesContent":[".pagination-block{\n  margin-top: 20px;\n}\n\n.pagination-button{\n  cursor: pointer;\n  margin-right: 4px;\n  width: 40px;\n  height: 40px;\n  background-color: #FFFFFF;\n  color: #434C63;\n  border: 1px solid #434C63;\n  border-radius: 5px;\n  transition: background-color linear .2s, color linear .2s;\n}\n\n.pagination-button:last-child{\n  margin-right: 0;\n}\n\n.pagination-button:hover{\n  background-color: #434C63;\n  color: #FFFFFF;\n}\n\n.pagination-button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.ellipsis{\n  display: inline-block;\n  width: 30px;\n  text-align: center;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
